import { changesPrefix } from "./constants";

export const getChangedPath = (property: string) => `${changesPrefix}.${property}`;
